import React, { useCallback, useState, useEffect } from 'react';
import {
  Empty,
  Loading
} from '../../component/common/index'
import {
  Footer
} from '../../component/housedetail'


const mock_data = {
  // link: 'https://ym0kkonnv5.feishu.cn/docs/doccn0GYD8YXbl4qBYlvlVvroSf#'
}

function HouseDetail(props) {
  const {
    pClassName
  } = props
  let timer = null
  let [src, setSrc] = useState('')
  let [loading, setLoading] = useState(false)
  let [data, setdata] = useState(mock_data)
  
  const clearTimer = useCallback(() => {
      timer &&  window.clearTimeout(timer)
      timer = null
      setLoading(false)
  }, [setLoading])

  const setTimer = useCallback(() => {
      timer && clearTimer()
      setLoading(true)
      timer = window.setTimeout(() => {
        clearTimer()
      }, 3000)
  }, [setLoading, clearTimer])

  const iframeLoad = useCallback(() => {
      let iframe = document.getElementById('m2m_detail_iframe');
      if (iframe) {
        iframe.src = src.replace('http:', 'https:')
        iframe.onload = () => {
          clearTimer()
        }
        setTimer()
      }
  }, [src])

  const changeSrc = useCallback((inputStr) => {
      setTimer()
      setSrc(inputStr.replace('http:', 'https:'))
  }, [setSrc, setTimer])

  useEffect(() => {
    iframeLoad()
    window.addEventListener('message', function (msg) {
      const {
          data
      } = msg
      if (data.type === "changeDetailIframe") {
          if (data.data)
          setdata(data.data)
          if (data.data.source) {
            changeSrc('/empty')
          } else {
            changeSrc(data.data.link)
          }
      }
    })
  }, [])

  const openNewTab = useCallback(() => {
    if (data && data.link){
      window.open(data.link)
    }
  }, [data])

  return (
    <div
      className={`h-[100vh] w-[100vw] ${pClassName}`}
    >
      <Loading loading={loading}/>
      {
        data && data.link ?
          <>
            {src === '/empty' ? <Empty data={data} pClassName='' /> : <iframe id='m2m_detail_iframe' className=' w-[100%] h-[100%]' src={src} />}
            <Footer
              openNewTab={openNewTab}
              data={data}
            />
          </>
          :
          <Empty />
      }
    </div>
  );
}

export default HouseDetail;
